import { DateTime } from 'luxon';
import IconDelete from '~/components/icons/streamline/line/IconDelete';
import IconEdit from '~/components/icons/streamline/line/IconEdit';
import InputAddressSearch from '~/components/input/InputAddress/InputAddressSearch';
import Button from '~/components/interactive/Button';
import { useZodFormFieldObject } from '~/components/zod/ZodForm';
import { DistanceAddress, GeocodedAddress } from '~/lib/model';
import { Column, Row } from '~/components/layout/Sections';
import InputText from '~/components/input/InputText';

interface ZodFieldAddressProps {
  name: string;
  distance?: GeocodedAddress;
  start?: DateTime;
  editable?: boolean;
  clearable?: boolean;
}

export default function ZodFieldAddress(props: ZodFieldAddressProps) {
  const [name, value, setValue] = useZodFormFieldObject<DistanceAddress>(props.name);

  let content = <InputAddressSearch distance={props.distance} start={props.start} onChange={setValue} />;

  if (value !== undefined && value.long) {
    content = (
      <Column gap>
        <Row>
          <span>{value.line1}</span>
          {props.clearable && (
            <Button
              type="button"
              variant="transparent"
              icon={<IconDelete />}
              onClick={(e) => {
                e.preventDefault();
                setValue(null);
              }}
            />
          )}
          {props.editable && (
            <Button
              type="button"
              variant="transparent"
              icon={<IconEdit />}
              onClick={(e) => {
                e.preventDefault();
                setValue(null);
              }}
            />
          )}
        </Row>
        <Row>
          <span className="text-sm">Line 2</span>
          <InputText
            placeholder="Unit #12345"
            value={value.line2 ?? undefined}
            onChange={(line2) =>
              setValue({
                ...value,
                line2,
              })
            }
          />
        </Row>
      </Column>
    );
  }

  return (
    <>
      <input type="hidden" name={`${name}.lat`} value={value?.lat ?? ''} />
      <input type="hidden" name={`${name}.long`} value={value?.long ?? ''} />
      <input type="hidden" name={`${name}.line1`} value={value?.line1 ?? ''} />
      {value?.line2 && <input type="hidden" name={`${name}.line2`} value={value.line2} />}
      <input type="hidden" name={`${name}.state`} value={value?.state ?? ''} />
      <input type="hidden" name={`${name}.city`} value={value?.city ?? ''} />
      {value?.neighborhood && <input type="hidden" name={`${name}.neighborhood`} value={value.neighborhood} />}
      <input type="hidden" name={`${name}.zip`} value={value?.zip ?? ''} />
      <input type="hidden" name={`${name}.distance`} value={value?.distance ?? ''} />
      <input type="hidden" name={`${name}.time`} value={value?.time ?? ''} />

      {content}
    </>
  );
}
